/**
 * Stepper — −/value/+ control for the humane schedule editor's time
 * pickers. Ported from design/project/lib/dash2.jsx; pixel values live
 * in the .ns-stepper classes in index.css.
 */

export interface StepperProps {
  value: number;
  onDec: () => void;
  onInc: () => void;
  /** Display formatter, e.g. zero-pad: (v) => String(v).padStart(2, "0"). */
  fmt?: (value: number) => string;
  /** Accessible name for the value being stepped (e.g. "hour"). */
  label?: string;
}

export function Stepper({ value, onDec, onInc, fmt = String, label }: StepperProps) {
  return (
    <div className="ns-stepper" role="group" aria-label={label}>
      <button type="button" onClick={onDec} aria-label={label ? `decrease ${label}` : "decrease"}>
        −
      </button>
      <span className="ns-stepper-value">{fmt(value)}</span>
      <button type="button" onClick={onInc} aria-label={label ? `increase ${label}` : "increase"}>
        +
      </button>
    </div>
  );
}
